var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldenBandcampSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-brands:bandcamp",
    clipPath: "url(#clip0_502_5434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5996 0.375C6.17774 0.375 0.974609 5.57812 0.974609 12C0.974609 18.4219 6.17774 23.625 12.5996 23.625C19.0215 23.625 24.2246 18.4219 24.2246 12C24.2246 5.57812 19.0215 0.375 12.5996 0.375ZM14.859 15.6609H6.37461L10.3449 8.34375H18.8293L14.859 15.6609Z",
    fill: "#FFDCA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_5434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenBandcampSvg);
export default __webpack_public_path__ + "static/media/GoldenBandcampSvg.2718302ad4ad7b597827218227a6d234.svg";
export { ForwardRef as ReactComponent };